"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OptionType;
(function (OptionType) {
    OptionType["drop_down"] = "drop_down";
    OptionType["color"] = "color";
})(OptionType = exports.OptionType || (exports.OptionType = {}));
var MediaItemType;
(function (MediaItemType) {
    MediaItemType["image"] = "image";
    MediaItemType["video"] = "video";
    MediaItemType["audio"] = "audio";
    MediaItemType["document"] = "document";
    MediaItemType["zip"] = "zip";
})(MediaItemType = exports.MediaItemType || (exports.MediaItemType = {}));
var ProductType;
(function (ProductType) {
    ProductType["physical"] = "physical";
    ProductType["digital"] = "digital";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
//# sourceMappingURL=product.dto.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixstores-platform-common/dist/src/products/product.dto.js
// module id = 15
// module chunks = 0